import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../Auth/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { id } = useParams();
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth is being checked
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // User not logged in - redirect to login
  if (!user) {
    // Prevent redirect if already on login page to avoid loop
    if (location.pathname === '/') {
      return null;
    }
    return <Navigate to="/" replace />;
  }

  const vendorId = user.id;

  // If URL has an ID that doesn't match user's ID, fix the URL
  if (id && id !== vendorId) {
    return <Navigate to={`/vendor/${vendorId}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
